<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="450"
  >
    <v-card>
      <v-card-title class="headline">
        {{ $t('message.forgot_password') }}
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="email"
          :label="$t('message.email')"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          flat
          @click="$emit('input', false)"
        >
          {{ $t('message.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="$emit('submit', email)"
        >
          {{ $t('message.send_reset_password_link') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    email: null,
  }),
}
</script>
